"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnavFooter = void 0;
const ac_1 = require("@app/ac");
const accept_or_deny_request_timeoff_1 = require("@app/ac/accept-or-deny-request-timeoff");
const remove_time_off_request_1 = require("@app/ac/remove-time-off-request");
const ui_1 = require("@app/component/ui");
const store_1 = require("@app/store");
const util_1 = require("@app/util");
const use_modal_1 = require("@app/util/modal/use-modal");
const react_1 = __importDefault(require("react"));
const react_hook_form_1 = require("react-hook-form");
const confirm_1 = __importDefault(require("../../confirm"));
const ActionsTimeOffConflict_1 = require("../../edit-unavailability/ActionsTimeOffConflict");
const unavailability_context_1 = require("../unavailability-context");
const toApproveData = (values) => {
    const { requestPendingAction: dontUseThisId, ...data } = values;
    return {
        ...data,
        period: {
            start: data.period?.start?.toJSON(),
            end: data.period?.end?.toJSON(),
        },
        attachments: data.attachments?.map((att) => att.id),
        recurrenceUpdateFollowing: (0, util_1.isDefined)(data.recurrence) && (0, util_1.isUndefined)(data.id),
    };
};
const UnavFooter = () => {
    const dispatch = (0, store_1.useRootDispatch)();
    const { getValues, handleSubmit, loading, setLoading, isRequestingAbsence, formControl, isEmployeeCalendar, canEdit, isEditing, initialData, initialLoad, afterSubmit, } = (0, unavailability_context_1.useUnavailability)();
    const { closeModal, openModal } = (0, use_modal_1.useModal)();
    const shifts = (0, store_1.useRootSelector)((state) => state.shifts);
    const hasUnavId = (0, util_1.isValue)(initialData?.id);
    const unavId = initialData?.id;
    const requestPendingAction = (0, react_hook_form_1.useWatch)({
        control: formControl,
        name: 'requestPendingAction',
    }) ?? initialData?.requestPendingAction;
    const isRequest = (0, util_1.isValue)(requestPendingAction);
    // snapshot of the loaded form, so approve can tell whether the manager changed anything
    const loadedApproveData = react_1.default.useRef();
    react_1.default.useEffect(() => {
        if (!initialLoad && (0, util_1.isUndefined)(loadedApproveData.current)) {
            loadedApproveData.current = JSON.stringify(toApproveData(getValues()));
        }
    }, [initialLoad, getValues]);
    const denyTimeOffRequest = react_1.default.useCallback(async () => {
        await dispatch((0, ac_1.acceptOrDenyRequest)({
            reply: 'no',
            id: requestPendingAction,
        }));
        closeModal();
        afterSubmit?.();
    }, [dispatch, requestPendingAction]);
    const cancelTimeOffRequest = react_1.default.useCallback(async () => {
        await dispatch((0, remove_time_off_request_1.removeTimeOffRequest)({ id: requestPendingAction ?? '' }));
        closeModal();
        afterSubmit?.();
    }, [dispatch, requestPendingAction]);
    const approveTimeOffRequest = react_1.default.useCallback(async () => {
        const approveData = toApproveData(getValues());
        // BE treats timeOffData as "manager edited the request" and recreates all its time offs
        // (new ids, one day's values for every day). Without it, the time offs are approved as they are.
        const isChanged = JSON.stringify(approveData) !== loadedApproveData.current;
        const result = await dispatch((0, accept_or_deny_request_timeoff_1.acceptOrDenyRequestTimeOff)({
            reply: 'yes',
            id: requestPendingAction ?? '',
            data: isChanged ? approveData : undefined,
        }));
        const _result = result?.data?.at(0);
        const hasConflictingShifts = (_result?.conflictingShifts?.length ?? -1) > 0;
        if (result?.result === 'ok' && hasConflictingShifts) {
            const conflictingShifts = _result?.conflictingShifts.map((shift) => shift._id);
            openModal(ActionsTimeOffConflict_1.ActionsTimeOffConflict, {
                conflictingShifts: shifts.filter((shift) => conflictingShifts?.some((sh) => sh === shift.id)),
                resultTimeOffs: _result?.timeOffs,
                afterClose: () => {
                    closeModal();
                },
            });
        }
        else {
            closeModal();
        }
        afterSubmit?.();
    }, [getValues, shifts, dispatch, requestPendingAction]);
    return (react_1.default.createElement("div", { style: {
            width: '100%',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
        } },
        hasUnavId && (react_1.default.createElement("div", { style: { width: '100%' } },
            react_1.default.createElement(ui_1.Text, { type: ui_1.Text.TYPES.BODY_SMALL },
                "DS ID:",
                react_1.default.createElement("span", { style: { cursor: 'pointer' }, onClick: () => util_1.miscUtil.copyToClipBoard(unavId) }, unavId)))),
        react_1.default.createElement("div", { style: {
                width: '100%',
                height: '100%',
                display: 'flex',
                gap: '0.5rem',
                justifyContent: 'end',
            } },
            react_1.default.createElement(ui_1.Button, { onClick: () => closeModal() }, (0, util_1.t)('CLOSE')),
            isRequest ? (isEmployeeCalendar ? (react_1.default.createElement(ui_1.Button, { style: 'CONTAINED', label: (0, util_1.t)('CANCEL_REQUEST'), onClick: () => openModal(confirm_1.default, {
                    title: (0, util_1.t)('DELETE_UNAVAILABILITY_REQUEST_CONFIRMATION'),
                    subtitle: (0, util_1.t)('DELETE_UNAVAILABILITY_REQUEST_CONFIRMATION'),
                    type: ui_1.Alert.TYPES.WARNING,
                    confirmLabel: (0, util_1.t)('CANCEL_REQUEST'),
                    cancelLabel: (0, util_1.t)('CLOSE'),
                    onConfirm: function () {
                        cancelTimeOffRequest();
                    },
                }) })) : (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(ui_1.Button, { label: (0, util_1.t)('REQUEST_UNAV_DENY'), size: ui_1.Button.SIZES.LARGE, disabled: !canEdit, onClick: denyTimeOffRequest }),
                react_1.default.createElement(ui_1.Button, { label: (0, util_1.t)('ATTEN_APPROVE'), size: ui_1.Button.SIZES.LARGE, style: ui_1.Button.STYLES.CONTAINED, disabled: !canEdit, onClickActiveWhenDisabled: true, onClick: approveTimeOffRequest })))) : null,
            !isRequest ? (react_1.default.createElement(ui_1.Button, { testid: isEditing ? 'save-timeoff-button' : 'add-timeoff-button', style: 'CONTAINED', disabled: loading || (isEmployeeCalendar ? false : !canEdit), onClick: async () => {
                    setLoading(true);
                    await handleSubmit();
                    setLoading(false);
                    afterSubmit?.();
                } }, isRequestingAbsence
                ? (0, util_1.t)('REQUEST_UNAVAILABILITY_MODAL_BTN')
                : isEditing
                    ? (0, util_1.t)('SAVE')
                    : (0, util_1.t)('ADD_UNAV_OR_SHIFT'))) : null)));
};
exports.UnavFooter = UnavFooter;
